module.exports = __webpack_public_path__ + "img/wvw_skirmish_claim_ticket.b017c73e.png";